
export default class Form {
	constructor(elem, settings) {
		this.elem = elem;

		this.formActionUrl = settings.formActionUrl;
		this.singleQuestions = settings.singleQuestions; // true/false
		this.transition = settings.transition; // slide/fade
		this.submitBtn = settings.submitBtn; // submit button text
		this.thankYouSlide = settings.thankYouSlide; // true/false
		this.thankYouTitle = settings.thankYouTitle;
		this.thankYouText = settings.thankYouText;
		this.json = {
			data: settings.json.data, // categories and nested questions
			categoryId: settings.json.categoryId,
			prerequisiteID: settings.json.prerequisiteID,
			prerequisiteValue: settings.json.prerequisiteValue,
			hasPrerequisite: settings.json.hasPrerequisite,
			prerequisites: settings.json.prerequisites,
			questionArray: settings.json.questionArray,
			questionId: settings.json.questionId,
			isOptional: settings.json.isOptional,
			regexValidation: settings.json.regexValidation,
			required: settings.json.required,
			questionText: settings.json.questionText,
			questionType: settings.json.questionType,
			answerOptions: settings.json.answerOptions,
			answerOptionsText: settings.json.answerOptionsText,
			answerOptionsValue: settings.json.answerOptionsValue,
			skipFormSubmit: settings.json.skipFormSubmit
		};
		this.questionTypes = settings.questionTypes;
	}

	validateInput(input, questionType) {
		if (questionType !== 'TrueFalse') {
			let required = input.dataset.required;
			let validation = input.dataset.regexvalidation;
			let regex = null;

			let dollar = /^(\d{1,3})+(,?(\d{3}))*$/;
			let zip = /^\d{5}(?:[-\s]\d{4})?$/;
			let phone = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
			let email = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

			let value = input.value;

			if (required === 'This field is required.' && value === '') {
				return false;
			}
			else if (validation != undefined && validation != 'undefined') {
				if (validation === 'dollar') {
					regex = dollar;
				}
				else if (validation === 'phone') {
					regex = phone;
				}
				else if (validation === 'email') {
					regex = email;
				}
				else if (validation === 'zipcode') {
					regex = zip;
				}

				if (regex.test(value)) {
					return true;
				}
				else {
					return false;
				}
			}
			else {
				return true;
			}
		}
		else {
			let inputChecked = false;

			for (let radio of input) {
				if (radio.checked) {
					inputChecked = true;
				}
			}

			return inputChecked;
		}
	}

	getQuestion(index, categoryIndex) {
		let nextIndex, nextCategoryIndex, categoryIndexChanged = false;

		//console.log('going forward to look for next question');

		// check up to the last question in the current category
		// or get the first question in the next category
		// if index is less than total items in a category
		if (index < parseInt(this.json.data[categoryIndex][this.json.questionArray].length) - 1) {
			nextIndex = index + 1;
			nextCategoryIndex = categoryIndex;
		}
		// if index is at end of category, jump to next one
		else if (index === parseInt(this.json.data[categoryIndex][this.json.questionArray].length) - 1) {
			nextIndex = 0;
			nextCategoryIndex = categoryIndex + 1;
			categoryIndexChanged = true;
		}

		let nextQuestionHtml = document.querySelectorAll(`.category-${nextCategoryIndex}-question-${nextIndex}`)[0];	
		let nextCategoryJson = this.json.data[nextCategoryIndex];
		let nextQuestionJson = nextCategoryJson[this.json.questionArray][nextIndex];

		// if category has a prerequisite, test that first as we can skip all questions if it doesn't match
		let nextJson = (nextCategoryJson.hasPrerequisite && categoryIndexChanged) ? nextCategoryJson : nextQuestionJson;


		if (categoryIndexChanged) {
			//console.log('category has changed to ' + nextCategoryJson[this.json.questionId] + '. it ' + (nextCategoryJson.hasPrerequisite ? 'has a prerequisite' : 'does not have a prerequisite'));

		//	console.log('category to test is: ');
			//console.log(nextJson);
		}
		else {
			//console.log('question to test is ');
			//console.log(nextQuestionJson);
		}

		// check if next question in series has a prerequisite
		if (nextJson.hasPrerequisite) {
			// if yes, find the value of the prerequisite question
			//console.log('testing prerequisite');
			let prerequisiteMet = false;

			for (let prerequisite of nextJson[this.json.prerequisites]) {
				let prerequisiteHtml = document.querySelectorAll(`.question-id-${prerequisite.questionId}`)[0];
				let prerequisiteValue = this.getPrerequisiteValue(prerequisiteHtml);

				if (prerequisiteValue != undefined && prerequisite.value === prerequisiteValue.value) {
					prerequisiteMet = true;
				}
			}


			// if the prerequisite values match, this is our next question
			if (prerequisiteMet) {
				//console.log('prerequisite is met. next question is seleted');
				return nextQuestionHtml;
			}
			else {
				//console.log('prerequisite is not met. testing next question');
				// else repeat process and check new next question
				if (nextCategoryJson.hasPrerequisite && categoryIndexChanged) {
					return this.getQuestion(nextCategoryJson[this.json.questionArray].length - 1, nextCategoryIndex);
				}
				else {
					return this.getQuestion(nextIndex, nextCategoryIndex);
				}
			}
		}
		else {
			//console.log('there is no prerequisite. next question is selected');
			// if not, this is the next question
			return nextQuestionHtml;
		}
	}

	getPrerequisiteValue(prerequisite) {
		let prerequisiteIndex = parseInt(prerequisite.dataset.index);
		let prerequisiteCategoryIndex = parseInt(prerequisite.closest('.category').dataset.index);
		let prerequisiteJson = this.json.data[prerequisiteCategoryIndex][this.json.questionArray][prerequisiteIndex];

		let questionType = this.convertType(prerequisiteJson[this.json.questionType]);
		return questionType !== 'TrueFalse' ? prerequisite.querySelectorAll('.form-control')[0] : prerequisite.querySelectorAll(`input[name="question-${prerequisiteJson[this.json.questionId]}"]:checked`)[0];
	}

	convertType(type) {
		for (let [key, value] of Object.entries(this.questionTypes)) {
			if (value === type) {
				return key;
			}
		}
	}

	createSelect(id, options, isOptional) {
		let select = `<select id="question-${id}" name="question-${id}" data-id="${id}" class="form-control" ${isOptional ? '' : 'data-required="This field is required."'}>
							<option value="">Select an option</option>
						`;

		for (let option of options) {
			select += `<option value="${option[this.json.answerOptionsText]}">${option[this.json.answerOptionsText]}</option>`
		}

		select += `</select><span class="field-validation error" data-valmsg-for="question-${id}"></span>`;

		return select;
	}

	createCountySelect(id, options, isOptional) {
		let select = `<select id="question-${id}" name="question-${id}" data-id="${id}" class="form-control county-select" ${isOptional ? '' : 'data-required="This field is required."'}>
							<option value="">Select an option</option>
						`;

		for (let option of options) {
			select += `<option value="${option[this.json.answerOptionsText]}">${option[this.json.answerOptionsText]}</option>`
		}

		select += `</select><span class="field-validation error" data-valmsg-for="question-${id}"></span>`;

		return select;
	}

	createInput(id, type, regexValidation, isOptional) {
		if (type === 'NumberEntry') {
			return `<input id="question-${id}" type="number" data-id="${id}" class="form-control" ${isOptional ? '' : 'data-required="This field is required."'} />
					<span class="field-validation error" data-valmsg-for="question-${id}"></span>`;
		}
		else if (type === 'DollarEntry') {
			return `<div class="dollar-input">
						<input data-id="${id}" id="question-${id}" data-inputmask="'alias': 'currency', 'digits': 0" type="text" class="form-control" ${isOptional ? '' : 'data-required="This field is required."'} />
					</div>
					<span class="field-validation error" data-valmsg-for="question-${id}"></span>`;
		}
		else if (type === 'DateEntry') {
			return `<input id="question-${id}" type="date" data-id="${id}" class="form-control date-picker" data-inputmask="'alias': 'date'" ${isOptional ? '' : 'data-required="This field is required."'} />
					<span class="field-validation error" data-valmsg-for="question-${id}"></span>`;
		}
		else if (type === 'Terminator') {
			return ``;
		}
		else {
			let mask = '';

			if (regexValidation === 'phone') {
				mask = 'data-inputmask="\'mask\': \'(999) 999-9999\'"';
			}
			else if (regexValidation === 'zipcode') {
				mask = 'data-inputmask="\'mask\': \'99999[-9999]\'"';
			}
			else if (regexValidation !== undefined) {
				mask = 'data-inputmask="\'alias\': \'' + regexValidation + '\'"';
			}
			else {
				mask = '';
			}

			return `<input id="question-${id}" type="text" data-id="${id}" class="form-control" ${mask} autocomplete="no" ${isOptional ? '' : 'data-required="This field is required."'} data-regexvalidation="${regexValidation}" />
					<span class="field-validation error" data-valmsg-for="question-${id}"></span>`;
		}
	}

	createTextarea(id, isOptional) {
		return `<textarea id="question-${id}" data-id="${id}" class="form-control" ${isOptional ? '' : 'data-required="This field is required."'}></textarea>
					<span class="field-validation error" data-valmsg-for="question-${id}"></span>`;
	}

	createTrueFalse(group) {
		return `<div class="radio-container">
					<input type="radio" data-id="${group}" name="question-${group}" id="yes-question-${group}" value="Yes" data-required="This field is required." />
					<label for="yes-question-${group}">Yes</label>
				</div>
				<div class="radio-container">
					<input type="radio" data-id="${group}" name="question-${group}" id="no-question-${group}" value="No" data-required="This field is required." />
					<label for="no-question-${group}">No</label>
				</div>
				<span class="field-validation error" data-valmsg-for="question-${group}"></span>`;
	}
}